import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M6.99992 0.333344C3.31992 0.333344 0.333252 3.32001 0.333252 7.00001C0.333252 10.68 3.31992 13.6667 6.99992 13.6667C10.6799 13.6667 13.6666 10.68 13.6666 7.00001C13.6666 3.32001 10.6799 0.333344 6.99992 0.333344ZM6.99992 7.66668C6.63325 7.66668 6.33325 7.36668 6.33325 7.00001V4.33334C6.33325 3.96668 6.63325 3.66668 6.99992 3.66668C7.36659 3.66668 7.66659 3.96668 7.66659 4.33334V7.00001C7.66659 7.36668 7.36659 7.66668 6.99992 7.66668ZM6.33325 9.00001V10.3333H7.66659V9.00001H6.33325Z";

export default function Warning(props: IconProps) {
  return (
    <SVGIcon
      path={path}
      viewBox="0 0 14 14"
      fillRule="evenodd"
      clipRule="evenodd"
      {...props}
    />
  );
}
